<child-header [title]="data.title" (closeEvent)="onNoClick()"></child-header>

<div mat-dialog-content>
  <ng-container *ngIf="data.scheduleChange">
    <p>
      Existing scheduled changes are pending.
      Proceeding will overwrite existing scheduled changes. 
  </p>
  </ng-container>
  <ng-container *ngIf="data.billing">
    <p>
      Your new ongoing charges after current term &nbsp;<span class="color-red bold"> {{data.billing |
        currency:'AUD':'symbol-narrow':'.2-2'}}</span>&nbsp;&nbsp;
    </p>   
  </ng-container> 
  <p *ngIf="data.cancelMessage" >{{data.cancelMessage}}</p>
  <p style="white-space: pre-line">{{data.text}}</p>
</div>
<div class="nce-dialog-action">
   <button mat-button class="button button-red button-nce-cancel nce-large-button"
    (click)="cancelSaveSubscription()">Cancel</button>
  <button mat-button class="button button-red button-large nce-large-button continue"
    (click)="continueSaveSubscription()">Continue</button>
</div>
